// extracted by mini-css-extract-plugin
export default {"root":"PaymentProgressBar_root__mRNem","animatedText":"PaymentProgressBar_animatedText__Dr1xD","shimmer":"PaymentProgressBar_shimmer__Up6r+"};